import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FieldEditorComponent } from './field-editor.component';
import {DxTabsModule} from 'devextreme-angular';
import {FieldEditorMapModule} from '../field-editor-map/field-editor-map.module';



@NgModule({
  declarations: [FieldEditorComponent],
  imports: [
    CommonModule,
    DxTabsModule,
    FieldEditorMapModule
  ],
  exports: [FieldEditorComponent]
})
export class FieldEditorModule { }
